module.exports = __webpack_public_path__ + "static/media/Layergrey.f7cdd6f9.svg";